// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Home from './Home'
import 'element-ui/lib/theme-chalk/index.css';
import '../../../static/css/theme.css'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import router from './router'
import axios from './request'
import Vuex from 'vuex'
import store from '@/store/store'
import mixins from './mixins'

Vue.use(ElementUI, { locale })

//import { Loading, Message } from 'element-ui'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.mixin(mixins)

/** */
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)


Viewer.setDefaults({
	Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.prototype.$axios = axios

Vue.prototype.$moment = moment;

router.beforeEach((to, from, next) => {
	/*
	 if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
	 if (store.state.token) {  // 通过vuex state获取当前的token是否存在
	 next();
	 }
	 else {
	 next({
	 path: '/login',
	 query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
	 })
	 }
	 }
	 else {
	 next();
	 }
	 */
	//console.log(to)
	//console.log(store.state.path)
	store.commit('setPath', to.path);
	console.log(store.state.path)

	if (store.state.isLogin) {
		next();
	} else {
		// window.location.href = "login.html";
		/*
		 next({
		 path: '/login',
		 query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
		 })
		 */
	}


})


Vue.directive('sort', {
	bind: function (el, binding, vnode) {
		//sorting_asc
		var vm = vnode.context;
		if (binding.value.sortable) {
			binding.value.sort_class = "";
			el.addEventListener('click', function () {
				binding.value.sort_class = binding.value.sort_class == 'sorting_asc' ? 'sorting_desc' : 'sorting_asc';
				vm.form.sort = (binding.value.sort_field ? binding.value.sort_field : binding.value.field) + "," + binding.value.sort_class.replace('sorting_', '');
				//删除
				vm.columns.forEach(function (value, i) {
					if (value.sortable && value.field != binding.value.field) {
						value.sort_class = '';
					}
				})
				vm.$router.push({query: vm.form});
			}, false);
			if (vm.form.sort && vm.form.sort.indexOf(binding.value.sort_field ? binding.value.sort_field : binding.value.field) != -1) {
				var _s = vm.form.sort.split(',');
				binding.value.sort_class = 'sorting_' + _s[1];
				el.className = binding.value.sort_class;
			} else {
				el.className = 'sorting';
			}

		}
	},
	update: function (el, binding, vnode) {
		if (binding.value.sort_class == '') {
			el.className = 'sorting';
		} else {
			el.className = binding.value.sort_class;
		}
	}
})


Vue.filter("datetime", function (t) {
	return !!t ? moment(t).tz(timezone).format('MM/DD/YYYY HH:mm:ss') : null;
});


/* eslint-disable no-new */

new Vue({
	el: '#main',
	store,
	router,
	components: {Home},
	template: '<Home/>'
})


/*
 new Vue({
 el: '#main',
 store,
 router,
 components: { Home },
 render: h => h(Home)
 })
 */



// WEBPACK FOOTER //
// ./src/views/main/index.js